var map = {
	"./": 215,
	"./Clutch": 492,
	"./Clutch/": 492,
	"./Clutch/index": 492,
	"./Clutch/index.js": 492,
	"./Clutch/style": 1123,
	"./Clutch/style.js": 1123,
	"./NewUi": 493,
	"./NewUi/": 493,
	"./NewUi/index": 493,
	"./NewUi/index.js": 493,
	"./NewUi/style": 1124,
	"./NewUi/style.js": 1124,
	"./OldUi": 494,
	"./OldUi/": 494,
	"./OldUi/index": 494,
	"./OldUi/index.js": 494,
	"./OldUi/style": 1125,
	"./OldUi/style.js": 1125,
	"./SpireonNew": 495,
	"./SpireonNew/": 495,
	"./SpireonNew/index": 495,
	"./SpireonNew/index.js": 495,
	"./SpireonNew/style": 1126,
	"./SpireonNew/style.js": 1126,
	"./SpireonOld": 496,
	"./SpireonOld/": 496,
	"./SpireonOld/index": 496,
	"./SpireonOld/index.js": 496,
	"./SpireonOld/style": 1127,
	"./SpireonOld/style.js": 1127,
	"./index": 215,
	"./index.js": 215,
	"./style": 227,
	"./style.js": 227
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 4180;
module.exports = webpackAsyncContext;